import axios from "./axiosInstance";
import {
    CashBoxCreatePayload,
    CashBoxClosePayload,
    CashBoxOpenTodayPayload,
    PaginatedCashBoxApiResponse,
    CashBoxSearchParams,
    CashBoxApiResponse
} from "../types/cashBoxTypes";
import { ApiResponse } from "types/apiTypes";


export const createCashBox = async (
    payload: CashBoxCreatePayload
): Promise<CashBoxApiResponse> => {
    const response = await axios.post<CashBoxApiResponse>("/cashbox", payload);
    return response.data;
};


export const openTodayCashBox = async (
    payload: CashBoxOpenTodayPayload = {}
): Promise<CashBoxApiResponse> => {
    const response = await axios.post<CashBoxApiResponse>(
        "/cashbox/open-today",
        payload
    );
    return response.data;
};


export const getAllCashBoxes = async (
    params: CashBoxSearchParams
): Promise<PaginatedCashBoxApiResponse> => {
    const response = await axios.get<PaginatedCashBoxApiResponse>("/cashbox", {
        params: { ...params }
    });
    return response.data;
};


export const getCashBoxById = async (
    cashBoxId: string
): Promise<CashBoxApiResponse> => {
    const response = await axios.get<CashBoxApiResponse>(
        `/cashbox/${cashBoxId}`
    );
    return response.data;
};


export const closeCashBox = async (
    cashBoxId: string,
    payload: CashBoxClosePayload
): Promise<CashBoxApiResponse> => {
    const response = await axios.post<CashBoxApiResponse>(
        `/cashbox/${cashBoxId}/close`,
        payload
    );
    return response.data;
};


export const deleteCashBox = async (
    cashBoxId: string
): Promise<CashBoxApiResponse> => {
    const response = await axios.delete<CashBoxApiResponse>(
        `/cashbox/${cashBoxId}`
    );
    return response.data;
};


export const getCashBoxUsers = async (): Promise<ApiResponse<any[]>> => {
  const response = await axios.get<ApiResponse<any[]>>("/cashbox/users");
  return response.data; 
};
